import { ReactElement } from 'react';

import { FieldOperations } from '@/modules/home';

const Operations = (): ReactElement => {
  return (
    <section className='rounded-2xl bg-background-neutral-99'>
      <FieldOperations />
    </section>
  );
};
export { Operations };
